import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import StateInterface, { BellaThunkDispatch } from '../../redux/types';
import { apiFetchClubIntegrationPixel } from '../../redux/user/actions';

interface ReduxDispatchProps {
    dispatchFetchClubIntegrationPixel: () => void;
}

export interface ClubIntegrationPixelProps {
    url: string;
    isLoggedIn: boolean;
}

const ClubIntegrationPixelImage = styled.img`
    display: none; /* the pixel is still loaded by the browser though */
`;

const ClubIntegrationPixel: FC<ClubIntegrationPixelProps & ReduxDispatchProps> = ({
    url,
    isLoggedIn,
    dispatchFetchClubIntegrationPixel,
}) => {
    // dispatch only once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => dispatchFetchClubIntegrationPixel(), []);

    useEffect(() => {
        if (isLoggedIn) {
            dispatchFetchClubIntegrationPixel();
        }
    }, [isLoggedIn, dispatchFetchClubIntegrationPixel]);
    return url ? <ClubIntegrationPixelImage src={url} alt="ClubIntegrationPixel" /> : null;
};

const mapStateToProps = (state: StateInterface) => {
    const { url } = state.clubIntegration;
    const { isLoggedIn } = state.login;
    return { url, isLoggedIn };
};

const mapDispatchToProps = (dispatch: BellaThunkDispatch): ReduxDispatchProps => ({
    dispatchFetchClubIntegrationPixel: () => {
        dispatch(apiFetchClubIntegrationPixel());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClubIntegrationPixel);
